import * as React from "react";
const SvgTrash = (props) => /* @__PURE__ */ React.createElement("svg", {
	width: "80%",
	height: "80%",
	viewBox: "0 0 12 14",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props
}, /* @__PURE__ */ React.createElement("path", { d: "M1.54349 12.25C1.54349 13.075 2.21849 13.75 3.04349 13.75H9.04349C9.86849 13.75 10.5435 13.075 10.5435 12.25V3.25H1.54349V12.25ZM11.2935 1H8.66849L7.91849 0.25H4.16849L3.41849 1H0.793488V2.5H11.2935V1Z" }));
export default SvgTrash;
